/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/no-extraneous-dependencies */
import React from "react";
import { FormControl, FormLabel } from "@chakra-ui/react";
import { Controller } from "react-hook-form";
import { TextArea } from "@progress/kendo-react-inputs";

export default function Remarks({
  name,
  isRequired,
  disabled,
  rows,
  errors,
  control,
  formControlStyles,
}) {
  return (
    <FormControl
      isRequired={Boolean(isRequired)}
      style={formControlStyles ? formControlStyles : {}}
    >
      <FormLabel>Remarks</FormLabel>
      <Controller
        control={control}
        name={name || "remarks"}
        render={({ field }) => {
          return (
            <TextArea
              rounded="medium"
              rows={rows || 3}
              disabled={disabled}
              style={{ height: "unset" }}
              value={field.value}
              onChange={(e) => {
                field.onChange(e.target.value);
              }}
            />
          );
        }}
      />

      {errors.remarks ? (
        <p className="error-message">{errors.remarks.message || ""}</p>
      ) : (
        <></>
      )}
    </FormControl>
  );
}
